export interface IContactFormInput {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export interface IValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}

export class ContactMessage implements IContactFormInput {
  name: string;
  email: string;
  subject: string;
  message: string;

  constructor(input: IContactFormInput) {
    this.name = input.name.trim();
    this.email = input.email.trim();
    this.subject = input.subject.trim();
    this.message = input.message.trim();
  }

  public validate(): IValidationResult {
    const errors: Record<string, string> = {};

    if (!this.name || this.name.length < 2) {
      errors.name = 'Full name must be at least 2 characters.';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.email || !emailRegex.test(this.email)) {
      errors.email = 'Please enter a valid email address.';
    }

    if (!this.subject) {
      errors.subject = 'Subject line is required.';
    }

    if (!this.message || this.message.length < 10) {
      errors.message = 'Message content must be at least 10 characters long.';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  public toJSON() {
    return {
      name: this.name,
      email: this.email,
      subject: this.subject,
      message: this.message,
      timestamp: new Date().toISOString()
    };
  }
}
